import aggregacao from "../aggregacao";
import { parseLabelCampo } from "../../../../constants/metricas";
import tiposFinanciamento from "../../../../constants/tiposFinanciamento";

const LARGURA_LABEL = 34;
const LARGURA_METRICA = 16;

function rotulo(texto, nivel) {
    return `${"  ".repeat(nivel)}${nivel > 0 ? "› " : ""}${texto}`;
}

// "Resumo por modalidade" com drilldown de verdade: agrupamento nativo do Excel
// (Dados > Agrupar, os botões +/- na margem esquerda), 3 níveis — modalidade
// (sempre visível) → curso (recolhido) → mês (recolhido) — espelhando os 3
// níveis já existentes no drill-down ao vivo do dashboard (ResumoModalidades/
// LinhaModalidade/LinhaCurso). `metaLinhas[i]` é paralelo a `linhas[i]` (mesmo
// índice de linha da planilha) com `{level, hidden}` pro `ws['!rows']`.
function planilhaResumoModalidade(linhas, mes) {
    let cabecalho = ["Modalidade", ...aggregacao.COLUNAS_RESUMO_MODALIDADE.map(parseLabelCampo)];
    let linhasSaida = [cabecalho];
    let metaLinhas = [{}];

    let linhaValores = (texto, nivel, dados) => [
        rotulo(texto, nivel),
        ...aggregacao.COLUNAS_RESUMO_MODALIDADE.map((campo) => dados[campo] || 0),
    ];

    let resumo = aggregacao.resumoPorModalidade(linhas, mes);
    let modalidades = resumo.filter((l) => l.modalidade !== "TOTAL");
    let totalGeral = resumo.find((l) => l.modalidade === "TOTAL");

    modalidades.forEach((linhaModalidade) => {
        linhasSaida.push(linhaValores(linhaModalidade.modalidade, 0, linhaModalidade));
        metaLinhas.push({ level: 0 });

        let linhasDaModalidade = linhas.filter((l) => l.modalidade === linhaModalidade.modalidade);
        let cursos = aggregacao.resumoPorCurso(linhasDaModalidade, mes);

        cursos.forEach((curso) => {
            let ehTotalCurso = curso.id === "TOTAL";
            let texto = ehTotalCurso ? "TOTAL" : `${curso.curso}${curso.unidade ? ` — ${curso.unidade}` : ""}`;
            linhasSaida.push(linhaValores(texto, 1, curso));
            metaLinhas.push({ level: 1, hidden: true });

            if (ehTotalCurso) return;

            let meses = aggregacao.detalheMensalCurso(linhasDaModalidade, curso.id);
            meses.forEach((linhaMes) => {
                linhasSaida.push(linhaValores(linhaMes.mes, 2, linhaMes));
                metaLinhas.push({ level: 2, hidden: true });
            });
        });
    });

    if (totalGeral) {
        linhasSaida.push(linhaValores("TOTAL", 0, totalGeral));
        metaLinhas.push({ level: 0 });
    }

    let cols = [{ wch: LARGURA_LABEL }, ...aggregacao.COLUNAS_RESUMO_MODALIDADE.map(() => ({ wch: LARGURA_METRICA }))];

    return { linhas: linhasSaida, metaLinhas, cols };
}

// Mesmo cruzamento de Relatorio/Exportacao/Tabela2 — cabeçalho de 2 linhas
// mescladas (Modalidades ocupa as 2 linhas; Número de Matrículas / Hora Aluno
// ocupam 4 colunas cada), sem drilldown (não foi pedido pra essa planilha).
function planilhaResumoUniplan(linhas, mes) {
    let colunasValor = [
        ...tiposFinanciamento.TIPOS.map(({ slug }) => `matricula_${slug}`),
        "matriculaTotal",
        ...tiposFinanciamento.TIPOS.map(({ slug }) => `hora_${slug}`),
        "horaTotal",
    ];

    let linhaValores = (linha) => [linha.modalidade, ...colunasValor.map((campo) => linha[campo] || 0)];

    let resumo = aggregacao.resumoUniplan(linhas, mes);
    let corpo = [
        ...resumo.linhasEP.map(linhaValores),
        linhaValores(resumo.totalEP),
        ...resumo.linhasFaculdade.map(linhaValores),
        linhaValores(resumo.totalFaculdade),
        linhaValores(resumo.totalGeral),
    ];

    let cabecalho1 = ["Modalidades", "Número de Matrículas", "", "", "", "Hora Aluno (% evasão)", "", "", ""];
    let cabecalho2 = ["", ...tiposFinanciamento.LABELS, "Total", ...tiposFinanciamento.LABELS, "Total"];

    let merges = [
        { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
        { s: { r: 0, c: 1 }, e: { r: 0, c: 4 } },
        { s: { r: 0, c: 5 }, e: { r: 0, c: 8 } },
    ];

    let cols = [{ wch: LARGURA_LABEL }, ...colunasValor.map(() => ({ wch: LARGURA_METRICA }))];

    return { linhas: [cabecalho1, cabecalho2, ...corpo], merges, cols };
}

// Lista plana de cursos (mesma granularidade do antigo DetalheCursos).
function planilhaCursos(linhas, mes) {
    let cabecalho = ["Curso", "Unidade", "CR", "Modalidade", "Tipo", "Turno", "Carga Horária", "Comentário", "Turmas"];
    let corpo = aggregacao.detalheCursos(linhas, mes).map((c) => (
        [c.curso, c.unidade, c.CR, c.modalidade, c.tipo, c.turno, c.cargaHoraria, c.comentario, c.turmas]
    ));
    let cols = cabecalho.map((_, indice) => ({ wch: indice === 0 ? LARGURA_LABEL : indice === 7 ? 30 : LARGURA_METRICA }));

    return { linhas: [cabecalho, ...corpo], cols };
}

export default { planilhaResumoModalidade, planilhaResumoUniplan, planilhaCursos };
